export default {
  year: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  month: {
    value: null,
    options: [
      {
        value: 1,
        text: 'JANEIRO'
      },
      {
        value: 2,
        text: 'FEVEREIRO'
      },
      {
        value: 3,
        text: 'MARÇO'
      },
      {
        value: 4,
        text: 'ABRIL'
      },
      {
        value: 5,
        text: 'MAIO'
      },
      {
        value: 6,
        text: 'JUNHO'
      },
      {
        value: 7,
        text: 'JULHO'
      },
      {
        value: 8,
        text: 'AGOSTO'
      },
      {
        value: 9,
        text: 'SETEMBRO'
      },
      {
        value: 10,
        text: 'OUTUBRO'
      },
      {
        value: 11,
        text: 'NOVEMBRO'
      },
      {
        value: 12,
        text: 'DEZEMBRO'
      }
    ],
    required: true,
    state: null
  },
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  weekControl: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  startDate: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  endDate: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/weeks/weeks-form.js